module.exports = __webpack_public_path__ + "img/banner_sub_info.5c06a30b.png";